export default function LiveDot() {
  return <span className="pulse-dot" data-testid="live-dot" aria-label="live" />;
}
